import './App.css';
import About from './components/About/About';
import Contact from './components/Contact/Contact';
import Intro from './components/Intro/Intro';
import Navbar from './components/Navbar/Navbar';
import Projects from './components/Projects/Projects';
import Skills from './components/Skills/Skills';
import { siteContent } from './content/portfolioContent';

function App() {
  const navigationItems = [
    { label: 'Home', target: 'intro' },
    { label: 'About', target: 'about' },
    { label: 'Projects', target: 'projects' },
    { label: 'Skills', target: 'skills' },
    { label: 'Contact', target: 'contact' },
  ];

  return (
    <main>
      <Navbar items={navigationItems} />
      <Intro content={siteContent.intro} />
      <About content={siteContent.about} />
      <Projects content={siteContent.projects} />
      <Skills content={siteContent.skills} />
      <Contact content={siteContent.contact} />
    </main>
  );
}

export default App;
